import { render, staticRenderFns } from "./NuevaCotizacion.vue?vue&type=template&id=81802e46"
import script from "./NuevaCotizacion.vue?vue&type=script&lang=js"
export * from "./NuevaCotizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports